import React from 'react'
import { Card } from '../ui/card'
import { TextInput } from '../inputs/Input'
import { MerchjarLogoMark } from '../../MerchjarLogo'
import classNames from 'classnames'

export const AuthPageChrome = ({ children, className, contentClassName }) => {
    return (
        <div
            className={classNames(
                'relative isolate min-h-screen w-full overflow-auto bg-gray-50 px-4 py-8',
                className,
            )}
        >
            <div
                className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
                aria-hidden="true"
            >
                <div className="absolute left-[75%] top-[33%] -translate-x-1/2 -translate-y-1/2 opacity-[0.06]">
                    <MerchjarLogoMark width={620} height={568} />
                </div>
            </div>

            <div
                className={classNames(
                    'mx-auto flex min-h-[calc(100vh-4rem)] w-full items-center justify-center',
                    contentClassName,
                )}
            >
                {children}
            </div>
        </div>
    )
}

export const AuthCard = ({ title, subtitle, children }) => {
    return (
        <div className="relative isolate flex justify-center items-center w-full h-full py-8">
            <div
                className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
                aria-hidden="true"
            >
                <div className="absolute left-[75%] top-[33%] -translate-x-1/2 -translate-y-1/2 opacity-[0.06]">
                    <MerchjarLogoMark width={620} height={568} />
                </div>
            </div>

            <div className="group/card w-full md:w-96 flex flex-col items-center">
                <div className="relative z-10 mb-[-24px] translate-y-1 transition-transform duration-200 ease-out group-focus-within/card:-translate-y-0.5">
                    <MerchjarLogoMark width={58} height={53} />
                </div>
                <Card className="w-full p-0 !rounded-[18px] !shadow-[0_22px_55px_rgba(14,41,71,0.16),0_8px_18px_rgba(14,41,71,0.08)]">
                    <div className="pt-12 px-8 pb-2 flex flex-col items-center text-center">
                        <h2 className="text-2xl font-semibold tracking-[-0.015em] text-gray-900">
                            {title}
                        </h2>
                        {subtitle && <div className="mt-2 text-xs text-gray-500">{subtitle}</div>}
                    </div>

                    <div className="px-8 pt-7 pb-8 flex flex-col gap-4">{children}</div>
                </Card>
            </div>
        </div>
    )
}

export const AuthTextInput = ({ icon, style = {}, ...props }) => {
    return (
        <div
            className={[
                'group',
                '[&_.bp4-input-group]:w-full',
                '[&_.bp4-input-group>div]:w-full',
                '[&_.bp4-icon]:transition-all',
                '[&_.bp4-icon]:duration-150',
                '[&_.bp4-icon]:ease-out',
                '[&_.bp4-input-group:focus-within_.bp4-icon]:translate-x-0.5',
                '[&_.bp4-input-group:focus-within_.bp4-icon]:scale-[1.03]',
                '[&_.bp4-input-group:focus-within_.bp4-icon_svg]:text-[#2d72d2]',
                '[&_.bp4-input]:transition-all',
                '[&_.bp4-input]:duration-150',
                '[&_.bp4-input]:ease-out',
                '[&_.bp4-input:focus]:!border-[#2d72d2]',
                '[&_.bp4-input:focus]:!bg-white',
                '[&_.bp4-input:focus]:!shadow-[0_0_0_3px_rgba(45,114,210,0.14),0_4px_12px_rgba(14,41,71,0.08)]',
            ].join(' ')}
        >
            <TextInput
                {...props}
                className="w-full"
                style={{
                    paddingLeft: icon ? 38 : undefined,
                    ...style,
                }}
                prefix={
                    icon
                        ? React.cloneElement(icon, {
                              className: 'text-gray-400',
                              size: 16,
                              strokeWidth: 1.8,
                          })
                        : undefined
                }
            />
        </div>
    )
}
